import { render, staticRenderFns } from "./DIASRealEstate.vue?vue&type=template&id=6dea3012&"
import script from "./DIASRealEstate.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports